/* eslint-disable import/no-unresolved */
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { calcAgeFromToday } from "src/helpers/FormDetails/ProposalDetails/resources";
import CustomLabel from "../../../../../shared/CustomLabel";
import CustomReviewField from "../../../../../shared/CustomReviewField";

function PrimaryReview() {
  const nomineeDetails = useAppSelector((state) => state.proposerDetails.nominee);
  const mefSchema = useAppSelector((state) => state.masterdata_reducer?.mefJourneySchema);
  const nomineeFields = mefSchema?.nomineeDetails || {};
  const appointeeFields = nomineeFields?.appointee || {};
  return (
    <div>
      <div className="flex justify-between mt-10">
        <div className="text-base font-bold">Primary Details</div>
      </div>
      <div className="font-montserrat text-black text-sm !font-normal">
        Particulars of the nominee (As per section 39 of Insurance Act 1938) (The person to whom the
        money secured by the policy shall be paid)
      </div>
      <div>
        {nomineeDetails?.nominee?.map((nominee, index) => (
          <div>
            {index > 0 && <hr className="mt-6" />}
            <div className="grid grid-flow-row-dense lg:grid-cols-3 grid-cols-2 gap-y-8 lg:gap-x-32 md:gap-x-36 gap-x-3 mt-6 max-sm:ml-4">
              {(nominee?.title || nomineeFields?.title?.visible) && (
                <div className="col-span-1">
                  <CustomLabel>{nomineeFields?.title?.label}</CustomLabel>
                  <CustomReviewField>{nominee?.title || "-"}</CustomReviewField>
                </div>
              )}

              {(nominee?.gender || nomineeFields?.gender?.visible) && (
                <div className="col-span-1">
                  <CustomLabel>{nomineeFields?.gender?.label}</CustomLabel>
                  <CustomReviewField>{nominee?.gender || "-"}</CustomReviewField>
                </div>
              )}
              {(nominee?.fullName || nomineeFields?.fullName?.visible) && (
                <div className="col-span-1">
                  <CustomLabel>{nomineeFields?.fullName?.label}</CustomLabel>
                  <CustomReviewField>{nominee?.fullName || "-"}</CustomReviewField>
                </div>
              )}
              {(nominee?.relationship || nomineeFields?.relationshipWithPrimary?.visible) && (
                <div className="col-span-1">
                  <CustomLabel>{nomineeFields?.relationshipWithPrimary?.label}</CustomLabel>
                  <CustomReviewField>{nominee?.relationship || "-"}</CustomReviewField>
                </div>
              )}
              {(nominee?.dob || nomineeFields?.dob?.visible) && (
                <div className="col-span-1">
                  <CustomLabel>{nomineeFields?.dob?.label}</CustomLabel>
                  <CustomReviewField>{nominee?.dob || "-"}</CustomReviewField>
                </div>
              )}

              {(nominee?.share || nomineeFields?.sharePercentage?.visible) && (
                <div className="col-span-1">
                  <CustomLabel>{nomineeFields?.sharePercentage?.label}</CustomLabel>
                  <CustomReviewField>{nominee?.share || "-"}</CustomReviewField>
                </div>
              )}

              {(nominee?.mobileNo || nomineeFields?.mobileNo?.visible) && (
                <div className="col-span-1">
                  <CustomLabel>{nomineeFields?.mobileNo?.label}</CustomLabel>
                  <CustomReviewField>{nominee?.mobileNo || "-"}</CustomReviewField>
                </div>
              )}
              {(nominee?.email || nomineeFields?.email?.visible) && (
                <div className="col-span-1">
                  <CustomLabel>{nomineeFields?.email?.label}</CustomLabel>
                  <CustomReviewField>{nominee?.email || "-"}</CustomReviewField>
                </div>
              )}
              {/* {(nominee?.captureBankDetails ||
                nomineeFields?.captureBankDetails?.visible) && (
                <div className="col-span-1">
                  <CustomLabel>{nomineeFields?.captureBankDetails?.label}</CustomLabel>
                  <CustomReviewField>
                    {nominee?.captureBankDetails ? "Yes" : "No"}
                  </CustomReviewField>
                </div>
              )} */}
              {(nominee?.bankName || nomineeFields?.bankName?.visible) && (
                <div className="col-span-1">
                  <CustomLabel>{nomineeFields?.bankName?.label}</CustomLabel>
                  <CustomReviewField>{nominee?.bankName || "-"}</CustomReviewField>
                </div>
              )}
              {(nominee?.ifscCode || nomineeFields?.ifscCode?.visible) && (
                <div className="col-span-1">
                  <CustomLabel>{nomineeFields?.ifscCode?.label}</CustomLabel>
                  <CustomReviewField>{nominee?.ifscCode || "-"}</CustomReviewField>
                </div>
              )}
              {(nominee?.bankAccountNumber || nomineeFields?.bankAccountNumber?.visible) && (
                <div className="col-span-1">
                  <CustomLabel>{nomineeFields?.bankAccountNumber?.label}</CustomLabel>
                  <CustomReviewField>{nominee?.bankAccountNumber || "-"}</CustomReviewField>
                </div>
              )}
              {(nominee?.pincode || nomineeFields?.pincode?.visible) && (
                <div className="col-span-1">
                  <CustomLabel>{nomineeFields?.pincode?.label}</CustomLabel>
                  <CustomReviewField>{nominee?.pincode || "-"}</CustomReviewField>
                </div>
              )}
              {(nominee?.address || nomineeFields?.address?.visible) && (
                <div className="col-span-1">
                  <CustomLabel>{nomineeFields?.address?.label}</CustomLabel>
                  <CustomReviewField>{nominee?.address || "-"}</CustomReviewField>
                </div>
              )}
              {calcAgeFromToday(nominee.dob) < 18 && (
                <>
                  {(nominee?.appointeeTitle || appointeeFields?.title?.visible) && (
                    <div className="col-span-1">
                      <CustomLabel>{appointeeFields?.title?.label}</CustomLabel>
                      <CustomReviewField>{nominee?.appointeeTitle || "-"}</CustomReviewField>
                    </div>
                  )}

                  {(nominee?.appointeeGender || appointeeFields?.gender?.visible) && (
                    <div className="col-span-1">
                      <CustomLabel>{appointeeFields?.gender?.label}</CustomLabel>
                      <CustomReviewField>{nominee?.appointeeGender || "-"}</CustomReviewField>
                    </div>
                  )}

                  {(nominee?.appointeeName || appointeeFields?.fullName?.visible) && (
                    <div className="col-span-1">
                      <CustomLabel>{appointeeFields?.fullName?.label}</CustomLabel>
                      <CustomReviewField>{nominee?.appointeeName || "-"}</CustomReviewField>
                    </div>
                  )}

                  {(nominee?.appointeeRelation ||
                    appointeeFields?.relationshipWithPrimary?.visible) && (
                    <div className="col-span-1">
                      <CustomLabel>{appointeeFields?.relationshipWithPrimary?.label}</CustomLabel>
                      <CustomReviewField>{nominee?.appointeeRelation || "-"}</CustomReviewField>
                    </div>
                  )}

                  {(nominee?.appointeeDob || appointeeFields?.dob?.visible) && (
                    <div className="col-span-1">
                      <CustomLabel>{appointeeFields?.dob?.label}</CustomLabel>
                      <CustomReviewField>{nominee?.appointeeDob || "-"}</CustomReviewField>
                    </div>
                  )}
                  {(nominee?.appointeeEmail || appointeeFields?.email?.visible) && (
                    <div className="col-span-1">
                      <CustomLabel>{appointeeFields?.email?.label}</CustomLabel>
                      <CustomReviewField>{nominee?.appointeeEmail || "-"}</CustomReviewField>
                    </div>
                  )}
                  {(nominee?.appointeeMobileNo || appointeeFields?.mobileNo?.visible) && (
                    <div className="col-span-1">
                      <CustomLabel>{appointeeFields?.mobileNo?.label}</CustomLabel>
                      <CustomReviewField>{nominee?.appointeeMobileNo || "-"}</CustomReviewField>
                    </div>
                  )}
                  {/* {(nominee?.captureAppointeeBankDetails ||
                    nomineeFields?.captureAppointeeBankDetails?.visible) && (
                    <div className="col-span-1">
                      <CustomLabel>{nomineeFields?.captureAppointeeBankDetails?.label}</CustomLabel>
                      <CustomReviewField>
                        {nominee?.captureAppointeeBankDetails ? "Yes" : "No"}
                      </CustomReviewField>
                    </div>
                  )} */}
                  {(nominee?.appointeeBankName || nomineeFields?.bankName?.visible) && (
                    <div className="col-span-1">
                      <CustomLabel>{nomineeFields?.bankName?.label}</CustomLabel>
                      <CustomReviewField>{nominee?.appointeeBankName || "-"}</CustomReviewField>
                    </div>
                  )}
                  {(nominee?.appointeeIfscCode || nomineeFields?.ifscCode?.visible) && (
                    <div className="col-span-1">
                      <CustomLabel>{nomineeFields?.ifscCode?.label}</CustomLabel>
                      <CustomReviewField>{nominee?.appointeeIfscCode || "-"}</CustomReviewField>
                    </div>
                  )}
                  {(nominee?.appointeeBankAccountNumber ||
                    nomineeFields?.bankAccountNumber?.visible) && (
                    <div className="col-span-1">
                      <CustomLabel>{nomineeFields?.bankAccountNumber?.label}</CustomLabel>
                      <CustomReviewField>
                        {nominee?.appointeeBankAccountNumber || "-"}
                      </CustomReviewField>
                    </div>
                  )}
                  {(nominee?.appointeePincode || appointeeFields?.pincode?.visible) && (
                    <div className="col-span-1">
                      <CustomLabel>{appointeeFields?.pincode?.label}</CustomLabel>
                      <CustomReviewField>{nominee?.appointeePincode || "-"}</CustomReviewField>
                    </div>
                  )}

                  {(nominee?.appointeeAddress || appointeeFields?.address?.visible) && (
                    <div className="col-span-1">
                      <CustomLabel>{appointeeFields?.address?.label}</CustomLabel>
                      <CustomReviewField>{nominee?.appointeeAddress || "-"}</CustomReviewField>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
export default PrimaryReview;
